import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018,2019. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/*
 *
 * Authentication reducer
 *
 */

import actionTypes from './actionTypes';
import { sessionStorage } from '../../utils/BrowserStorageUtils';
/**
 * Returns the user name from the browser session.
 * If the user is logged in, but they refresh the page, this check will
 * avoid re-authenticating with the server as the username is cached locally.
 *
 * @returns {string} the logged in username.
 * @private
 */

function getLoggedInUserFromBrowserSession() {
  return sessionStorage.getItem('username');
}
/**
 * Returns the user account details from the browser session.
 * If the user is logged in, but they refresh the page, this check will
 * avoid re-authenticating with the server as the user account details are cached locally.
 *
 * @returns {Object} the logged in user account details.
 * @private
 */


function getUserAccountFromBrowserSession() {
  var userAccount = sessionStorage.getItem('user_account');

  if (userAccount) {
    return JSON.parse(userAccount);
  }

  return null;
}
/**
 * Authentication reducer
 * @param {*} state the current state.
 * @param {*} action a valid user preferences action.
 * @returns {state} the next state.
 */


function authenticationReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    loggedInUser: getLoggedInUserFromBrowserSession(),
    userAccount: getUserAccountFromBrowserSession(),
    ssoToken: null
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case actionTypes.SET_LOGGED_IN_USER:
      return _Object$assign({}, state, {
        loggedInUser: action.loggedInUser
      });

    case actionTypes.SET_USER_ACCOUNT:
      return _Object$assign({}, state, {
        userAccount: action.userAccount
      });

    case actionTypes.SET_SSO_TOKEN:
      return _Object$assign({}, state, {
        ssoToken: action.ssoToken
      });

    default:
      return state;
  }
}

export default {
  authenticationReducer: authenticationReducer
};